import SidebarMenu from './SidebarMenu/SidebarMenu.vue';

export default {
  components: { SidebarMenu },
};
